/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentCategoryDto } from '../../models/content-category-dto';
import { UpdateContentCategoryDto } from '../../models/update-content-category-dto';

export interface AdminContentCategoryControllerUpdate$Params {

/**
 * 카테고리 ID
 */
  id: string;
      body: UpdateContentCategoryDto
}

export function adminContentCategoryControllerUpdate(http: HttpClient, rootUrl: string, params: AdminContentCategoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentCategoryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentCategoryDto>;
    })
  );
}

adminContentCategoryControllerUpdate.PATH = '/api/content-category/admin/{id}';
